module.exports = __webpack_public_path__ + "img/icon-get-valued-automation.93f269ed.svg";